import { render, staticRenderFns } from "./ProjectTotal.vue?vue&type=template&id=021e3dda&"
import script from "./ProjectTotal.vue?vue&type=script&lang=js&"
export * from "./ProjectTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports